import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';

//Componentes
import { CrearCombustibleComponent } from '@/app/components/catalogos/Combustibles/crear-combustible/crear-combustible.component';
import { EditarCombustibleComponent } from '@/app/components/catalogos/Combustibles/editar-combustible/editar-combustible.component';

//Servicios 
import { CombustiblesService } from '@/app/services/combustibles.service';

//librerias externas 
import {MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

//Modelos 
import { Combustibles } from '@/app/models/Combustibles';
@Component({
    selector: 'app-lista-combustibles',
    templateUrl: './lista-combustibles.component.html',
    styleUrls: ['./lista-combustibles.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaCombustiblesComponent {
  private spinner = inject(NgxSpinnerService);

   //Lista de combustibles
   listaCombustibles: Combustibles[] = [];

   constructor(
    private combustiblesService: CombustiblesService,
    private toastr: ToastrService, 
    private router: Router,
    private dialog: MatDialog,

   ){
    this.obtenerCombustibles();
   }

   obtenerCombustibles(){
    this.spinner.show();

    this.combustiblesService.obtenerCombustibles().subscribe({
      next: (data: any)=>{
        this.listaCombustibles = data.Combustible;
        this.spinner.hide();
      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  abrirModalCrearCombustible(){
    const dialogRef = this.dialog.open(CrearCombustibleComponent, {
      width: '550px',
      height: '320px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerCombustibles();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  abrirModalEditarCombustible(combustible: Combustibles){
    const dialogRef = this.dialog.open(EditarCombustibleComponent, {
      width: '550px',
      height: '320px',
      panelClass: 'custom-dialog-container',
      data: combustible,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerCombustibles();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }
}
